import createReducer from '../utils/createReducer';
import actions from '../actions/brandDetermination';
import {checkBankingLocBtnStatus, isUsSite} from '../utils/validate';


const initialState = {};

const actionHandlers = {
    [actions.HANDLE_BANKING_LOC_FIELD_VALUE_CHANGE](state, {payload}) {
        const bankingCountryList = state.bankingCountryList;
        switch (payload.fieldName) {

            case 'bankingCountry': {
                const primarySite = state?.primarySiteMap?.[payload.fieldValue] ? state.primarySiteMap[payload.fieldValue] : null;
                const currencyList = primarySite? primarySite.currencies : [];

                return {
                    ...state,
                    bankingCountryCode: payload.fieldValue,
                    bankingCountryInfo: (bankingCountryList instanceof Array) ? bankingCountryList.find((e) => e.countryCode === payload.fieldValue) : null,
                    primarySite,
                    currencyList,
                    currency: currencyList.length === 1 ? currencyList[0] : '',
                };
            }

            case 'currencySelection': return {
                ...state,
                currency: payload.fieldValue
            }

            default: return {
                ...state
            };
        }
    },

    [actions.BRAND_DETERMINATION_FIELD_ERROR](state, {payload}) {
        switch (payload.fieldName) {

            case 'bankingCountry': return {
                ...state,
                bankingCountryCodeError: payload.msg
            };

            case 'currencySelection': return {
                ...state,
                currencyError: payload.msg
            };

            default: return {
                ...state
            };
        }
    },

    [actions.TOGGLE_BANKING_LOC_CONTINUE_BUTTON](state, {}) {
        const enableContinueButton = checkBankingLocBtnStatus(state);
        return {
            ...state,
            enableContinueButton
        };
    },

    [actions.BRAND_DETERMINATION_ERROR](state, {payload}) {
        return {
            ...state,
            serviceError: payload.errorKey
        };
    },

    [actions.DISMISS_ALERT_BOX](state, {}) {
        return {
            ...state,
            serviceError: ''
        };
    },

    [actions.GET_SUPPORTED_SITES_SUCCESS](state, {payload}) {
        const siteName = payload.siteName;
        const countryCodeForSite = Object.keys(payload.primarySiteMap || {}).find(countryCode =>
            payload.primarySiteMap[countryCode].name === siteName
        );
        let prefillBrand = {}
        if (countryCodeForSite && !isUsSite(siteName)) {
            const primarySite = payload.primarySiteMap[countryCodeForSite];
            const currencyList = primarySite? primarySite.currencies : [];
            prefillBrand = {
                bankingCountryCode: countryCodeForSite,
                bankingCountryInfo: payload.countryList?.find((e) => e.countryCode === countryCodeForSite),
                primarySite,
                currencyList,
                currency: currencyList.length === 1 ? currencyList[0] : '',
            }
        }
        const enableContinueButton = checkBankingLocBtnStatus(prefillBrand);
        return {
            ...state,
            ...prefillBrand,
            bankingCountryList: payload.countryList,
            primarySiteMap: payload.primarySiteMap,
            enableContinueButton
        };
    },
};

export default createReducer(actionHandlers, initialState);
